<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12 mb-4">
        <h1>Benvenuti in Aegent</h1>
      </div>
    </div>

    <div class="row">
      <!-- Colonna Sinistra: Spiegazione -->
      <div class="col-md-4">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title">Navigazione Rapida</h5>
            <p class="card-text">
              Benvenuto nel sistema di gestione della rendicontazione dei progetti.
            </p>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <a href="#/projects" class="d-block text-decoration-none">
                  <i class="fas fa-project-diagram me-2"></i><strong>Projects</strong>
                  <br><small class="text-muted">Gestione progetti e ripartizione per anno del budget dei progetti</small>
                </a>
              </li>
              <li class="list-group-item">
                <a href="#/people" class="d-block text-decoration-none">
                  <i class="fas fa-users me-2"></i><strong>People</strong>
                  <br><small class="text-muted">Gestione anagrafica personale con i budget previsti per anno</small>
                </a>
              </li>
              <li class="list-group-item">
                <a href="#/budget" class="d-block text-decoration-none">
                  <i class="fas fa-euro-sign me-2"></i><strong>Budget</strong>
                  <br><small class="text-muted">In questa sezione si definiscono i budget assegnati per ogni persona e progetto</small>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Colonna Destra: Dashboard -->
      <div class="col-md-8">
        <ApiLoader>
          <template #error>
            <div class="alert alert-info">
            Si prega di effettuare il login per accedere ai dati.
            </div>
          </template>
          <div class="row" v-if="store.apiResult?.data?.stats">
            <div class="col-md-3 mb-3">
              <router-link to="/projects" class="text-decoration-none">
                <div class="card text-white bg-primary h-100" style="cursor: pointer; transition: transform 0.2s;" @mouseenter="$event.currentTarget.style.transform='scale(1.02)'" @mouseleave="$event.currentTarget.style.transform='scale(1)'">
                  <div class="card-header">Progetti Attivi</div>
                  <div class="card-body">
                    <h2 class="card-title">{{ store.apiResult.data.stats.projects }}</h2>
                    <p class="card-text">Progetti</p>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-md-3 mb-3">
              <router-link to="/people" class="text-decoration-none">
                <div class="card text-white bg-success h-100" style="cursor: pointer; transition: transform 0.2s;" @mouseenter="$event.currentTarget.style.transform='scale(1.02)'" @mouseleave="$event.currentTarget.style.transform='scale(1)'">
                  <div class="card-header">Persone</div>
                  <div class="card-body">
                    <h2 class="card-title">{{ store.apiResult.data.stats.people }}</h2>
                    <p class="card-text">Persone</p>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-md-6 mb-3">
              <router-link to="/budget" class="text-decoration-none">
                <div class="card text-white bg-info h-100" style="cursor: pointer; transition: transform 0.2s;" @mouseenter="$event.currentTarget.style.transform='scale(1.02)'" @mouseleave="$event.currentTarget.style.transform='scale(1)'">
                  <div class="card-header">Budget Totale</div>
                  <div class="card-body">
                    <h2 class="card-title">€ {{ formatCurrency(store.apiResult.data.stats.budget) }}</h2>
                    <p class="card-text">Budget complessivo progetti</p>
                  </div>
                </div>
              </router-link>
            </div>
          </div>

          <!-- Grafico Budget -->
          <div class="row mt-4" v-if="store.apiResult?.data?.chart">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  Andamento Budget per Anno
                </div>
                <div class="card-body">
                  <BudgetChart :chart-data="store.apiResult.data.chart" />
                </div>
              </div>
            </div>
          </div>
        </ApiLoader>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useAppStore } from '../stores/app.js'
  import { ref, watch } from 'vue'
  import ApiLoader from '../lib/ApiLoader.vue'
  import BudgetChart from '../components/BudgetChart.vue'

  const store = useAppStore()
  
  // Chiama la api di dashboard usando apiStore per gestire lo stato in ApiLoader
  store.apiStore("/project/dashboard");

  const formatCurrency = (value) => {
    if (!value) return '0,00';
    return parseFloat(value).toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }


  watch(() => store.user, (newResult, oldResult) => {
    console.log('apiResult changed:', newResult)

    let uid_old=oldResult?.uid;
    let uid_new=newResult?.uid;
    if(uid_old!=uid_new){
      store.apiStore("/project/dashboard");      
    }
  })
</script>